export default function PHP_xml_parser_get_option() {
  return (
    <div>
      <h1>PHP_xml_parser_get_option</h1>
    </div>
  );
}
